export const deInvoiceTermsUrl =
  'https://cdn.zaver.com/DE/docs/de-invoice-terms.pdf';

export const supportedCountryCodes = [46, 49, 31, 32, 43, 358, 56, 385];
